import React from "react"

function IconPhoneDown({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="phone-down"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-phone-down"
      {...props}
    >
      <path
        d="M22.083 15.607c-.399.4-.915.639-1.47.687l-.21.01-2.333-.002a2.38 2.38 0 0 1-2.368-2.18l-.008-.195v-1.033a.993.993 0 0 0-.83-.972 15.723 15.723 0 0 0-2.728-.237c-.92 0-1.837.079-2.73.237a.997.997 0 0 0-.82.844l-.009.128v1.033c0 .635-.247 1.232-.695 1.68-.399.4-.915.639-1.47.687l-.21.008-2.334.001a2.36 2.36 0 0 1-1.68-.696c-.46-.46-.611-1.043-.677-1.524l-.02-.156.002-1.063c0-1.116.439-2.175 1.195-2.932.136-.135.283-.263.44-.378 1.41-1.041 3.118-1.837 4.94-2.303 1.311-.338 2.68-.51 4.067-.51 1.39 0 2.758.172 4.07.51 1.82.466 3.529 1.263 4.94 2.303.958.709 1.556 1.84 1.628 3.064l.007.246v1.063c0 .634-.397 1.381-.697 1.68zm-.925-.925c.1-.101.258-.433.3-.655l.012-.1v-1.063c0-.905-.417-1.75-1.103-2.256-1.273-.94-2.827-1.664-4.49-2.09a15.04 15.04 0 0 0-3.74-.468c-1.28 0-2.54.159-3.745.47-1.661.424-3.215 1.148-4.49 2.09-.1.074-.197.157-.288.248a2.828 2.828 0 0 0-.803 1.778l-.01.228v.981l.016.122c.045.285.116.486.226.632l.071.082c.17.17.381.274.612.304l.141.01 2.336-.002c.287 0 .55-.108.753-.311.17-.169.273-.38.303-.613l.009-.142v-1.035a2.303 2.303 0 0 1 1.91-2.26 16.99 16.99 0 0 1 2.957-.256c.991-.001 1.984.086 2.96.257a2.304 2.304 0 0 1 1.9 2.066l.008.195v1.032c0 .542.41.993.934 1.059l.133.008 2.333.001c.288 0 .552-.11.755-.312z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconPhoneDown
